export default __webpack_public_path__ + "static/media/16.41d74cf2.gif";